import { WithGetSet } from "./types";

export const calcRulesBase = {
	applyFunctions: function(
		name,
		datahash: WithGetSet<number | string | boolean>,
		missinghash: WithGetSet<boolean>
	) {}
};
